import { InitialiseScoreUploadResponse } from "../../types/upload/InitialiseScoreUploadResponse";
import { ValidationResult } from "../../types/forms/ValidationResult";
import { UpdateScoreUploadMappingsRequest } from "../../types/admin/score-uploader/UpdateScoreUploadMappingsRequest";
import { UploadStatusResponse } from "../../types/admin/score-uploader/UploadStatusResponse";
import { ErrorReportDetailDto } from "../../types/admin/score-uploader/ErrorReportDetailDto";
import { apiClient } from "../apiClient";

class scoreUploadApi {
  constructor(authToken: string | undefined) {
    this.accessToken = authToken;
  }

  accessToken: string | undefined;

  initialiseExternalScoreUpload(
    file: File,
    hasHeaderRow: boolean,
    /** This comes in as a string from the frontend picker, but the server expects a date object
     * but to avoid timezone issues, we send it as a string
     */
    dataDate: string | null,
    onSuccess: (data: InitialiseScoreUploadResponse) => void,
    onError: (error: unknown) => void
  ) {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("hasHeaderRow", hasHeaderRow.toString());
    formData.append("dataDate", dataDate || "");

    return apiClient(
      this.accessToken,
      "dashboards/upload/initialise-external-score-upload",
      {
        method: "POST",
        body: formData,
        headers: {
          // Don't set Content-Type header - browser will set it with correct boundary for FormData
        },
      }
    ).then(
      (data) => {
        onSuccess(data as InitialiseScoreUploadResponse);
      },
      (error) => {
        onError(error);
      }
    );
  }

  updateUploadWithMappings(
    request: UpdateScoreUploadMappingsRequest,
    onSuccess: (data: ValidationResult) => void,
    onError: (error: unknown) => void
  ) {
    return apiClient(
      this.accessToken,
      "dashboards/upload/update-upload-mappings",
      {
        method: "POST",
        body: JSON.stringify(request),
      }
    ).then(
      (data) => {
        onSuccess(data as ValidationResult);
      },
      (error) => {
        onError(error);
      }
    );
  }

  markUploadReadyForProcessing(
    uploadId: string,
    onSuccess: () => void,
    onError: (error: any) => void
  ) {
    return apiClient(
      this.accessToken,
      "dashboards/upload/mark-upload-ready-for-processing?uploadId=" + uploadId
    ).then(
      () => {
        onSuccess();
      },
      (error) => {
        onError(error);
      }
    );
  }

  getUploadStatusProgress(
    uploadId: string,
    onSuccess: (data: UploadStatusResponse) => void,
    onError: (error: unknown) => void
  ) {
    return apiClient(
      this.accessToken,
      `dashboards/upload/get-upload-status-progress?uploadId=${uploadId}`
    ).then(
      (data) => {
        onSuccess(data as UploadStatusResponse);
      },
      (error) => {
        onError(error);
      }
    );
  }

  getUploadErrorReportDetails(
    uploadId: string,
    onSuccess: (data: ErrorReportDetailDto) => void,
    onError: (error: unknown) => void
  ) {
    return apiClient(
      this.accessToken,
      `dashboards/upload/get-upload-error-report-details?uploadId=${uploadId}`
    ).then(
      (data) => {
        const dto: ErrorReportDetailDto = {
          unmatchedIdentifiers: data as string[],
        };
        onSuccess(dto);
      },
      (error) => {
        onError(error);
      }
    );
  }
}

export default scoreUploadApi;
